













































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { config } from "@/config";
import { IToken, ITokenNetwork } from "@/interfaces";
import Alert from "@/components/Alert.vue";

@Component({ components: { Alert } })
export default class Modal extends Vue {
    @Prop({ required: true }) public isOpen: boolean;

    public tokens: Array<{ label: string; value: { token: string; network: string } }> = [];
    public selectedToken: { token: string; network: string } = {
        token: "dijets",
        network: "mainnet",
    };
    public customAddressPrefix: number | null = null;
    public customWIF: number | null = null;
    public useCustom: boolean = false;
    public error: string | null = null;

    public mounted(): void {
        for (const token of Object.values(config.getTokens())) {
            for (const [network, details] of Object.entries(token.networks)) {
                this.tokens.push({
                    label: `${token.name} | ${network.charAt(0).toUpperCase() + network.slice(1)}`,
                    value: { token: token.name, network },
                });
            }
        }

        if (this.useCustom) {
            this.customAddressPrefix = config.getAddressPrefix();
            this.customWIF = config.getWIF();
        }

        this.selectedToken = this.tokens[0].value;
    }

    private close(): void {
        this.$emit("close");
    }

    private toggleCustom(value: boolean): void {
        this.useCustom = value;
    }
}
